import React, { useState } from "react"
import { Row, Input, Form, Col } from "antd"
import "./ChooseRestaurant.scss"
import {
  NO_RESTAURANT,
  RESTAURANT_SEARCH,
  THANK_YOU,
  SUGGESTION_SAVED,
  RESTAURANT_NAME_PLACEHOLDER,
  SAVE_BUTTON,
  INTERVAL_TIME,
  TRY_CHANGING_YOUR_LOCATION,
  BACK_BUTTON,
  RESTAURANT_SELECT_LABEL,
} from "../../constants/messages"
import { connect } from "react-redux"
import { restaurantWishList } from "../../redux/actionCreators/planDinnner"
import AutoCompleteRestaurants from "../RestaurantAutoSuggest/RestaurantAutoSuggest"
import { withFormik } from "formik"
import { TextTag, Button } from "../../atoms"
import searchIcon from "../../assets/images/SearchIcon.svg"
import { PageHeader } from "../../molecules/PageHeader"
import { ArrowLeftOutlined } from "@ant-design/icons"
import Separator from "../Separator/Separator"
import { FirebaseContext } from "../../firebase"
import _ from "../../utils/lodashUtils"

const S = (props) => {
  const [isSearchHidden, toggleIshidden] = useState(false)
  const [isSuggestionSaved, setIsSuggestionSaved] = useState(false)
  const [isNoClicked, setIsNoClicked] = useState(false)
  const { partnerState } = React.useContext(FirebaseContext)
  const partnerName = _.get(partnerState, "userDetails.display_name", "Partner")
  const {
    values,
    handleChange,
    handleBlur,
    restaurantList,
    setRestaurantList,
  } = props

  const showSearchBar = () => {
    let value = isSearchHidden
    toggleIshidden(!value)
  }
  const submitData = () => {
    props.restaurantWishList(values).then((success) => {
      if (success.status === 200 && success.data.restaurant_list.length > 0)
        setIsSuggestionSaved(true)

      values.restaurantName = ""
    })

    setTimeout(function () {
      setIsSuggestionSaved(false)
    }, INTERVAL_TIME)
  }

  return (
    <div id="ChooseRestaurant">
      <div id="dinnerPlanSection">
        <div id="dinnerPlan">
          <div className="no-restaurant-heading">
            <TextTag textType="sectionHeading" id="dinnerPlanHeading">
              {NO_RESTAURANT}
            </TextTag>
          </div>
          <Separator />
          <div className="dinner-plan-sub-heading">
            <TextTag textType="default">
              {TRY_CHANGING_YOUR_LOCATION(partnerName)}
            </TextTag>
          </div>
          {isNoClicked && (
            <div id="thanksMsg">
              <TextTag className="info-msg">{THANK_YOU}</TextTag>
            </div>
          )}
          {isSearchHidden !== null && !isSearchHidden && (
            <div id="noRestaurantBox">
              <Row id="HeaderRow">
                <section id="dinnerPlanInput">
                  <div className="searchbar-hotel">
                    <img
                      className="search-icon"
                      src={searchIcon}
                      alt="location"
                    />
                    <AutoCompleteRestaurants
                      setRestaurantList={setRestaurantList}
                      restaurantList={restaurantList || []}
                    />
                  </div>
                </section>
              </Row>
              <Row className="save-btn-row">
                <Button
                  btnType="primary"
                  className="search-save-btn"
                  onClick={submitData}
                >
                  {" "}
                  {SAVE_BUTTON}
                </Button>
              </Row>
            </div>
          )}

          {isSearchHidden !== null && isSearchHidden && (
            <div className="select-restaurant">
              <div id="thanksMsg" className="info-msg">
                {isSuggestionSaved ? (
                  <TextTag>{SUGGESTION_SAVED}</TextTag>
                ) : (
                  <TextTag>{THANK_YOU}</TextTag>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const NoRestaurantsHeader = withFormik({
  mapPropsToValues: (props) => ({
    restaurantName: "",
  }),
})(S)
export default connect(null, { restaurantWishList })(NoRestaurantsHeader)
